import React from 'react';
import { Term, HeadContainer, PaymentNotice } from './proposal-tabs.styled';
export const ProposalHead = ({ term, noticeLabel, isSelected }) => (React.createElement(HeadContainer, null,
    React.createElement(Term, { isSelected: isSelected, strong: true }, term),
    React.createElement(PaymentNotice, { isSelected: isSelected }, noticeLabel)));
//# sourceMappingURL=proposal-head.js.map